import { tv } from 'tailwind-variants';

export const aiActivityRecipe = tv({
  slots: {
    container: `
      flex w-full flex-col overflow-hidden rounded-xl border bg-brand-surface
    `,
    header: `flex select-none items-center justify-between px-3 py-2 gap-2`,
    chevron: `transition-transform duration-200`,
    icon: '',
    title: '',
  },
  variants: {
    type: {
      default: {
        container: 'border-brand-border',
        header: `
          cursor-pointer
          hover:bg-c-surface-hover
          active:bg-c-surface-active
        `,
      },
      gather: {
        container: 'border-brand-border',
        header: `
          cursor-pointer
          hover:bg-c-surface-hover
          active:bg-c-surface-active
        `,
      },
      action: {
        container: 'border-brand-border',
        header: `
          cursor-pointer
          hover:bg-c-surface-hover
          active:bg-c-surface-active
        `,
      },
      handover: {
        container: 'border-brand-orange-10',
        header: `
          border-b border-brand-orange-10 bg-brand-orange-6 text-brand-orange-14
        `,
        icon: 'text-current',
        title: 'text-current',
      },
      ai: {
        container: 'border-brand-border',
        header: `
          cursor-pointer
          hover:bg-c-surface-hover
          active:bg-c-surface-active
        `,
      },
      respond: {
        container: 'border-brand-border',
        header: `
          cursor-pointer
          hover:bg-c-surface-hover
          active:bg-c-surface-active
        `,
      },
      wait: {
        container: 'border-brand-border',
        header: `
          cursor-pointer
          hover:bg-c-surface-hover
          active:bg-c-surface-active
        `,
      },
      complete: {
        container: 'border-brand-border',
        header: `
          cursor-pointer
          hover:bg-c-surface-hover
          active:bg-c-surface-active
        `,
      },
    },
    size: {
      normal: {
        header: 'py-2',
      },
      sm: {
        header: 'py-1.5',
      },
    },
    isOpen: {
      true: {},
      false: {},
    },
    isCollapsible: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      type: [
        'default',
        'gather',
        'action',
        'ai',
        'respond',
        'wait',
        'complete',
      ],
      isOpen: true,
      class: {
        header: 'border-b border-brand-border bg-brand-surface-secondary',
      },
    },
    {
      isOpen: true,
      class: {
        chevron: 'rotate-90',
      },
    },
  ],
  defaultVariants: {
    type: 'default',
    size: 'normal',
    isOpen: false,
    isCollapsible: true,
  },
});

/**
 * @typedef {import('tailwind-variants').VariantProps<typeof aiActivityRecipe>} AiActivityRecipeVariants
 */
